import { saveDashboard } from "./db"
import { nanoid } from 'nanoid';
import { globalRouter } from "../globalRouter";
import qs from 'query-string';
import { getFeature } from "@src/globalStore/featureStore";
import featureNames from "../featureToggle/constants";
import { getDrilldownUrl, openNewTab } from "./drilldown";
import { logger } from "../misc/logger";

// TODO: if this approach is replacing all temp dashboard,
// could nanoid cause a conflict with nexa session ids
export const createClientTempDashboard = async ({ type, config, title, options = {}, id = nanoid(), meta = {}  }) => {

  await saveDashboard({
    id,
    type,
    config,
    title,
    meta,
  });

  const { urlSearch, redirectHandler, newBrowserTab = false } = options as any;
  const url = qs.stringifyUrl({
    url: getDrilldownUrl(type, id),
    query: urlSearch,
  });

  // new tab workflow
  const newBrowserTabFeature = getFeature(featureNames.NEW_BROWSER_TAB_WORKFLOW);
  if(newBrowserTabFeature && newBrowserTab) {
    openNewTab(url);
    return;
  }

  // pulse tab
  if ('redirectHandler' in options) {
    redirectHandler({ id });
  } else {
    globalRouter.navigate(url);
  }

  logger.log('created new dashboard', { id });
}
